export function sentryCaptureException(e, extra) {
  window.Sentry.withScope(scope => {
    scope.setExtras(extra);
    window.Sentry.captureException(e);
  })
}